<template>
  <div>
    <no-data v-if="!examsList.length && dataLoadState"></no-data>
    <div v-if="examsList.length" class="container container--narrow pdt-30 ">
      <div class="mdc-card  mgb-50 pdb-8" >
        <div class="t-headline7 font-m  mgb-16 mgr-12 pdt-24 pdl-24">{{$t('183')}}</div>
        <div v-for="(exam, index) in examsList" :key="index"
             :class="[exam.status === 'WAITING'?'':'cursor-pointer', exam.icon ? '':'withoutIcon24']" class="d-flex pdt-16 pdl-24 my-course-list position-relative" >
          <div v-if="exam.icon" class="list-image-small40">
            <img :src="exam.icon" alt="" class="circle w-40 h-40">
          </div>
          <div :class="exam.icon ? 'pdl-20': ''" class="flex-grow-1 ">
            <div class="mgb-16">
              <div class="t-body1 font-r pdr-24 l-spacing48 pdb-4">
                {{exam.name}}
              </div>
              <!-- <div v-if="exam.status === 'COMPLETION'" @click="takeFinalExam(exam.examineeId)"> -->
              <div v-if="exam.status === 'COMPLETION'">
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA  pdb-8">
                  {{$t('185', {str: exam.score})}}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA">
                  {{$t('184')}}
                </div>

              </div>
              <div v-if="exam.status === 'WAITING'" @click="watingPopup" @keypress="watingPopup" tabindex="0" >
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA pdb-8">
                  {{$t('924', {str: $moment(exam.application.start).format('L')})}}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA ">
                  {{$t('923')}}
                </div>
              </div>
              <div v-if="exam.status === 'APPLICABLE'" @click="takeFinalExam(exam.examineeId)" @keypress="takeFinalExam(exam.examineeId)" tabindex="0">
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA pdb-8">
                  {{ $t('186', { str: displayEndPeriod(exam.application.end) }) }}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray">
                  {{$t('190')}}
                </div>
              </div>
              <div v-if="exam.status === 'REAPPLICATION'" @click="takeFinalExam(exam.examineeId)" @keypress="takeFinalExam(exam.examineeId)" tabindex="0">
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA pdb-8">
                  {{ $t('186', { str: displayEndPeriod(exam.application.end) }) }}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray">
                  {{$t('185', {str: exam.score})}}
                  <span class="t-body6 t-color-red pdl-8">
										{{$t('188')}}
									</span>
                </div>
              </div>
              <div v-if="exam.status === 'TERMINATION'"  @click="examExpried()" @keypress="examExpried()" tabindex="0">
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyGrayA pdb-8">
                  {{$t('924', {str: $moment(exam.application.start).format('L')})}}
                </div>
                <div class="t-body6  font-r pdr-24 l-spacing45 t-color-bodyBlueGray">
                  {{$t('922')}}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <transition name="slide">
        <router-view></router-view>
      </transition>
    </div>
  </div>
</template>


<script>
/**
 * 나의 학습 상세 - 정규평가 탭 컴포넌트(my learning view - exam tab component)
 *
 * @author minkyoung.park@emcast.com
 */

// Components/Mixin/Extend/API define
import httpService from '@/api/httpService'
import learnApi from '@/api/learnApi.js'
import NoData from '../../common/NoDataExamLessson.vue'
import {MDCRipple} from '@material/ripple'
import { utilDateMixin } from "@/mixins/dateUtil";

export default {
  components: {
    'no-data': NoData
  },
  mixins: [utilDateMixin],
  data() {
    return {
      examsList: [],
      dataLoadState: false,
      statusTab: null
    }
  },
  watch: {
    $route(to, from) {
      let getExamResult = this.$route.query.examresult;
      if(getExamResult == 'getscore') {
        this.fetchData()
      }
    },
  },
  mounted() {
    this.statusTab = this.$route.query.status;
    let getExamResult = this.$route.query.examresult;
    if(getExamResult == 'getscore') {
      this.fetchData()
    } else {
      this.fetchData()
    }
  },

  updated() {
    const ripples = [].map.call(document.querySelectorAll('.ripple-item'), function(el) {
      let ripple = new MDCRipple.attachTo(el)
      return ripple
    })
  },

  methods: {
    // 시험정보 API 호출 및 데이터 설정(get exam list data)
    fetchData() {
      let responseData = null
      let params = this.setParams()
      this.$showLoading(this.$refs.examList)
      learnApi.learnViewExams(params).then((response) => {
        this.examsList = response.data.data
        this.$hideLoading()
        this.dataLoadState = true
        let applicableExamList = _.filter(this.examsList, function(o) { return o.status === 'APPLICABLE' || o.status === 'REAPPLICATION' })
        if (applicableExamList) {
          let examineeId = _.head(applicableExamList).examineeId
          this.setExamineeId(examineeId)
        }
      }).catch((err) => {

      })
    },

    // 파라미터 설정(set parameter)
    setParams() {
      const params = {
        learnId: this.$route.params.learnId
      }
      return params
    },

    // 시험응시(move take exam)
    takeFinalExam(examineeId) {
      let query = this.$route.query;
      query.type='regular-evolution'
      this.$confirm({
        title: this.$t("1652"),
        content: this.$t("1653") + " <br/>" + this.$t("1654"),
        accept: this.$t("1656"),
        cancel: this.$t("1655"),
      }).then(() => {
        this.$router.push({
          name: 'FinalExamIntro',
          params: {
            learnId: this.$route.params.learnId,
            examineeId: examineeId
          },
          query: query
        })
      }).catch(() => {});
    },

    setExamineeId(examineeId) {
      this.$emit('setExamineeId', examineeId)
    },
    watingPopup(){
      let alertData = {
        title: this.$t('1657'),
        content: this.$t('1658')+'<br>'+this.$t('1659'), //'TODO-제출이 완료되었습니다. 결과는 성적 조회기간에 가능합니다.',
        accept: this.$t('1660'), //'TODO-확인',
      }
      this.$alert(alertData).then(() => {
      }).catch(() => {})
    },
    examExpried(){
      let alertData = {
        title: '학습 기간이 만료되었습니다.',
        content: '안타깝게도 학습 기간이 만료되어 더 이상 학습 활동을 할 수 없습니다.', //'TODO-제출이 완료되었습니다. 결과는 성적 조회기간에 가능합니다.',
        accept: '확인', //'TODO-확인',
      }
      this.$alert(alertData).then(() => {
      }).catch(() => {})
    }
  }
}
</script>